import React from 'react';
import { connect } from 'react-redux';
import agent from '../agent';
import ArtistPreview from './ArtistPreview';
import ArtistList from './ArtistList';
import Gallery from './Gallery';
import Sidebar from './Sidebar';
import { AutoComplete } from 'material-ui';
import { BlockList } from 'net';

const mapDispatchToProps = dispatch => {
  agent.Artists.all(dispatch);
  agent.Mediums.all(dispatch);
  return {}
};

const mapStateToProps = state => ({
  ...state.artists,
  ...state.mediums
});

const styles = {
  li: {
    listStyle: "none"
  },
  link: {
    color: '#A0A0A0',
    fontSize: '14px',
    textDecoration: 'none',
    fontWeight: '300'
  },
  ul: {
    padding: '0'
  }
}

class MainView extends React.Component {

  buildElements(start, end, artists) {
    var elements = [];
    for (var i = start; i < end; i++) {
        elements.push(artists[i]);
    }
    return elements;
  }

  render() {
    if(!this.props.artists || !this.props.mediums) return null;

    let artists = [];
    let currArtists = [];

    if(!this.props.medium && !this.props.search) {
      artists = this.props.artists.map(artist => <ArtistPreview artist={artist} key={artist.id} />);
    } else if(this.props.medium && !this.props.search) {

      artists = this.props.artists.filter(artist => {
        let hasMedium = false;

        if(artist.mediums) {
          artist.mediums.map(medium => {
            if (medium === this.props.medium) hasMedium = true;
          });
        }

        return hasMedium;
      });

      artists = artists.map(artist => <ArtistPreview artist={artist} key={artist.id} />);
    } else {
      artists = this.props.artists.filter( artist => {
        let match = false;

          if(artist.name.toLowerCase().includes(this.props.search.toLowerCase()) ||
             artist.agency.toLowerCase().includes(this.props.search.toLowerCase()) ||
             artist.location.toLowerCase().includes(this.props.search.toLowerCase()) ||
             artist.previous.toLowerCase().includes(this.props.search.toLowerCase())
            ) {
            match = true;
          }

        return match;
      });

      artists = artists.map(artist => <ArtistPreview artist={artist} key={artist.id} />);
    }

    return (
      <div>

        <div style={{display: 'flex'}}>
          <div style={{fontWeight: '400', margin: '20px', padding: '0px 20px 20px', position: 'fixed'}}>
            <img src="/static/media/logo.png" width="125" style={{margin:'0 auto', display:'block'}} />

            <Sidebar mediums={this.props.mediums} />
          </div>
          <div className="col-md-9" style={{marginLeft: '200px'}}>
            <ArtistList artists={artists} />
          </div>
        </div>

        <Gallery />

      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainView);



// WEBPACK FOOTER //
// ./src/components/MainView.js